import { render, staticRenderFns } from "./IconStatusRevision.vue?vue&type=template&id=341b97f2&scoped=true"
import script from "./IconStatusRevision.vue?vue&type=script&lang=js"
export * from "./IconStatusRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b97f2",
  null
  
)

export default component.exports